{
  "(optional)": "(opcional)",
  "(required)": "(obligatorio)"
}
